export default {
  displayMobileNav (state, getters) {
    return state.displayMobileNav
  },
  toast (state, getters) {
    return state.toast
  },
  isNutritionist: (state, getters) => {
    if (state.isNutritionist) {
      return state.isNutritionist
    } else {
      return false
    }
  },
  showSpinner: (state, getters) => {
    return state.showSpinner
  }
}



// WEBPACK FOOTER //
// ./src/app/store/misc/getters.js